import { AnalysisDetailContext } from "Components/Analyses/Detail/AnalysisDetailContext";
import { PdfQuestionnaireEmpty } from "Components/PdfQuestionnaire/PdfQuestionnaireEmpty";
import { PdfTemplatePage } from "Components/PdfTemplate/PdfTemplatePage";
import { useParams } from "react-router-dom";

export const PdfTemplateQuestionnaireEmptyPage = () => {
  const { analysisId, versionId } = useParams() as {
    analysisId: string;
    versionId: string;
  };

  return (
    <AnalysisDetailContext.Provider value={{ analysisId, versionId, readOnly: true, canAddFamilyMember: false }}>
      <PdfTemplatePage>
        <PdfQuestionnaireEmpty />
      </PdfTemplatePage>
    </AnalysisDetailContext.Provider>
  );
};
